"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Categories;
(function (Categories) {
    Categories["SOFTWARE"] = "38d56eb4-a8f2-11eb-bcbc-0242ac130002";
    Categories["PRODUCT_CATALOGUE"] = "3d88c6fb2481473dba6e3bc4ab8feef7";
})(Categories || (Categories = {}));
exports.default = Categories;
